{
    "data": {
        "AppsInstallState": {
            "type": "object",
            "properties": {
                "stateMap": {
                    "type": "object",
                    "properties": {},
                    "default": {},
                    "additionalProperties": {
                        "type": "object",
                        "properties": {
                            "status": {
                                "type": "string",
                                "enum": [
                                    "INSTALLED",
                                    "REMOVED"
                                ],
                                "default": "INSTALLED"
                            },
                            "version": {
                                "type": [
                                    "string",
                                    "null"
                                ],
                                "minLength": 1,
                                "maxLength": 20
                            },
                            "codeReferenceId": {
                                "type": [
                                    "string",
                                    "null"
                                ],
                                "minLength": 1,
                                "maxLength": 40
                            },
                            "overrideCodeReferenceId": {
                                "type": [
                                    "string",
                                    "null"
                                ],
                                "minLength": 1,
                                "maxLength": 40
                            }
                        },
                        "required": [
                            "status"
                        ]
                    }
                }
            },
            "isTopLevelDataNode": true,
            "additionalProperties": false
        }
    }
}
